import React from 'react';
import { ProfilePicture } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';
import { marked } from 'marked';
import dompurify from 'dompurify';
import { Eye, EyeOff } from 'lucide-react';
import moment from 'moment';
import PropTypes from 'prop-types';

const bodySx = {
  '&& *:first-child': { mt: 0, marginBlockStart: '0 !important' },
  '&& h1, h2': { color: 'text' },
  '&& strong': { fontWeight: 'medium' },
  '&& p': { mb: '0' },
  '&& p + p': { mt: '8px' },
};

export const NoteContent = ({ note, type, headerEnd }) => (
  <Flex width="100%" flexDirection="column" sx={{ gap: '8px' }}>
    <Flex alignItems="center" justifyContent={headerEnd ? 'space-between' : undefined} sx={{ gap: '8px' }}>
      <Flex alignItems="center" sx={{ gap: '8px' }}>
        {note.author && (
          <>
            <Box width="24px" height="24px" flex="0 0 auto">
              <ProfilePicture name={note.author.fullName} imageUrl={note.author.avatarUrl} />
            </Box>
            <Text fontSize="14px" fontWeight="medium">
              {note.author.fullName}
            </Text>
            {note.createdAt && (
              <Text fontSize="14px" color="text.subtle">
                {moment(note.createdAt).format('MMM D, YYYY')}
              </Text>
            )}
            {type !== 'public' && (
              <>
                {note.external ? (
                  <Flex alignItems="center" color="text.subtle" sx={{ gap: '8px' }}>
                    <Box as={Eye} width="16px" height="16px" aria-hidden="true" />
                    <Text fontSize="14px" fontWeight="medium">
                      Visible to companies
                    </Text>
                  </Flex>
                ) : (
                  <Flex alignItems="center" color="text.subtle" sx={{ gap: '8px' }}>
                    <Box as={EyeOff} width="16px" height="16px" aria-hidden="true" />
                    <Text fontSize="14px" fontWeight="medium">
                      Internal
                    </Text>
                  </Flex>
                )}
              </>
            )}
          </>
        )}
      </Flex>
      {headerEnd}
    </Flex>
    {note.title?.length > 0 && (
      <Text fontSize="14px" fontWeight="medium" color="text.dark">
        {note.title}
      </Text>
    )}
    {(note.body?.length ?? 0) > 0 && (
      <Text fontSize="14px">
        <Box
          dangerouslySetInnerHTML={{
            __html: dompurify.sanitize(marked(note.body || '')),
          }}
          sx={bodySx}
        />
      </Text>
    )}
  </Flex>
);

NoteContent.propTypes = {
  note: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['default', 'read', 'matches', 'public']),
  headerEnd: PropTypes.node,
};

NoteContent.defaultProps = {
  type: 'default',
  headerEnd: null,
};
